<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    华新站<br>
站点介绍<br>
华新站坐落于红荔路与华强北路交界，是深圳地铁3、7号线换乘站。周围的主要信息包括B出入口群星广场、C出入口圣廷苑酒店 、MEGO时尚商业街 、A2出入口华强北商业街、E出入口深圳实验初中部 D出入口旺角美食城、深圳中心公园。华新站是深圳福田区华新村命名而来。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:10	23:58	3号线	2分15-20秒	4分30秒<br>
双龙	06:04	23:15	3号线	2分15-20秒	4分30秒<br>
西丽湖	06:34	23:14	7号线	3分35秒	5分55秒<br>
太安	06:15	23:43	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:18	23:57	3号线	3分15秒	5分钟<br>
双龙	06:00	23:15	3号线	3分15秒	5分钟<br>
西丽湖	06:33	23:14	7号线	4分钟	5分55秒<br>
太安	06:14	23:43	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:18	00:57	3号线	3分15秒	5分钟<br>
双龙	06:00	00:15	3号线	3分15秒	5分钟<br>
西丽湖	06:34	00:14	7号线	4分钟	5分55秒<br>
太安	06:14	00:43	7号线	4分钟	5分55秒<br><br>
<br>
站点出口信息<br><br>
A1出入口:<br>
红荔路南侧（西）、上步工业区、万源大厦、时尚MEGO地铁商城（西区）<br><br>
A2出入口:<br>
华强北步行街、儿童世界、南方大厦、上航大厦、中航路、茂业天地、华强珠宝世界<br>
B出入口:<br>
红荔路南侧(东)、华发北路、华强北街道办、红荔村、赛格科技园、群星广场<br><br>
C出入口:<br>
红荔路北侧(东)、百花七路、长城幼儿园、百花小学、深圳实验中学初中部、长城花园、长泰花园、时尚MEGO地铁商城（东区） 圣廷苑酒店<br><br>
D出入口:<br>
红荔路北侧(东)、华新村、交行大厦<br><br>
E出入口:<br>
华强北路东侧、长泰花园、长城社区工作站、百花四路、长怡花园<br><br>
F出入口:<br>
华强北路西侧、华新村、交行大厦、海馨苑、华新路<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 华新村<br>
64路、385路、M183路<br><br>
A1出入口:<br>
公交站名： 华新村①<br>
10路、13路、225路、303路、322路、高峰专线122路、M105路<br><br>
A1出入口:<br>
公交站名： 华新村②<br>
12路、216路、371路<br><br>
B出入口:<br>
公交站名： 群星广场1始发站<br>
高峰专线119路，高快巴士4路<br><br>
B出入口:<br>
公交站名： 群星广场<br>
13路、64路、225路、303路、385路、216路、E10路、M183路、高峰专线122路<br><br>
C出入口:<br>
公交站名： 群星广场<br>
13路、64路、 107路、216路、225路、303路、385路、E10路、M105路、M183路、M202路、高峰专线122路<br><br>
D出入口:<br>
公交站名： 华新村①<br>
M105路、225路、303路、10路、322路、高峰专线122路、13路、M183路、64路、385路<br><br>
D出入口:<br>
公交站名： 华新村②<br>
12路、216路、371路、M202路<br><br>
D出入口:<br>
公交站名： 华新村<br>
64路、385路、M183路、107路<br><br>
F出入口:<br>
公交站名： 华新路<br>
M132路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>